import { useEffect } from 'react';

import { useSoyuzClientConfig } from '@spotahome/soyuz/client';

const MAPBOX_VERSION = 'v3.21.0';
const MAPBOX_SCRIPT_ID = 'mapbox-gl-script';
const MAPBOX_STYLESHEET_ID = 'mapbox-gl-stylesheet';
const MAPBOX_SCRIPT_URL = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_VERSION}/mapbox-gl.js`;
const MAPBOX_STYLESHEET_URL = `https://api.mapbox.com/mapbox-gl-js/${MAPBOX_VERSION}/mapbox-gl.css`;

const ensureStylesheet = () => {
  if (document.getElementById(MAPBOX_STYLESHEET_ID)) return;
  const link = document.createElement('link');
  link.id = MAPBOX_STYLESHEET_ID;
  link.rel = 'stylesheet';
  link.href = MAPBOX_STYLESHEET_URL;
  document.head.appendChild(link);
};

const loadScript = () => {
  if (window.mapboxgl) return Promise.resolve();

  const existing = document.getElementById(MAPBOX_SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = MAPBOX_SCRIPT_ID;
    script.src = MAPBOX_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

export const useGoogleMapsScript = callback => {
  const { mapboxAccessToken } = useSoyuzClientConfig();

  useEffect(() => {
    ensureStylesheet();
    loadScript().then(() => {
      window.mapboxgl.accessToken = mapboxAccessToken;
      callback();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default {
  useGoogleMapsScript
};
